import React, { createContext, useState, useEffect, useCallback, useContext } from "react";
import axiosPrivate from "../axios/axiosPrivate";
import { AuthContext } from "./AuthContext";

export const WalletContext = createContext(null);

// The shopper's HAYD wallet (store credit) during checkout: the balance, and whether they chose to use it.
export const WalletProvider = ({ children }) => {
  const [balance, setBalance] = useState(0);
  const [useWalletCredit, setUseWalletCredit] = useState(false);
  const [loaded, setLoaded] = useState(false);
  // Who is logged in. The balance is asked again whenever this changes, so logging in (or out) on the checkout
  // page shows (or hides) the wallet without a page refresh. Address edits keep the same id and ask nothing.
  const auth = useContext(AuthContext);
  const userId = auth?.user?.id ?? null;
  const authLoading = auth?.authLoading ?? false;

  const refresh = useCallback(async () => {
    try {
      const res = await axiosPrivate.get("/orders/wallet-balance");
      setBalance(Number(res?.data?.data?.balance || 0));
    } catch (error) {
      setBalance(0);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (authLoading) return;
    if (!userId) {
      setBalance(0);
      setLoaded(true);
      return;
    }
    refresh();
  }, [refresh, userId, authLoading]);

  // Turn the option off on its own if the balance is zero.
  useEffect(() => {
    if (balance <= 0 && useWalletCredit) setUseWalletCredit(false);
  }, [balance, useWalletCredit]);

  return (
    <WalletContext.Provider
      value={{ balance, useWalletCredit, setUseWalletCredit, walletLoaded: loaded, refreshWallet: refresh }}
    >
      {children}
    </WalletContext.Provider>
  );
};
